import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import * as moment from "moment";
import Skeleton from "react-loading-skeleton";

const RowSkeleton = () => {
  return (
    <Row className="align-items-center">
      <div className="col-md-auto">
        <div className="avatar-md mb-md-0 mb-4">
          <Skeleton width={"100%"} height={"100%"} />
        </div>
      </div>
      <div className="col-md">
        <h4 className="fw-semibold">
          <Skeleton width={150} height={24} />
        </h4>
        <div className="hstack gap-3 flex-wrap">
          <div className="text-muted">
            <Skeleton width={100} height={16} />
          </div>
          <div className="vr"></div>
          <div className="text-muted">
            <Skeleton width={120} height={16} />
          </div>
          <div className="vr"></div>
          <div className="text-muted">
            <Skeleton width={140} height={16} />
          </div>
        </div>
      </div>
    </Row>
  );
};

const Header = ({ agency, loading }: { agency: any; loading: Boolean }) => {
  return (
    <React.Fragment>
      <Col lg={12}>
        <Card className="rounded-0">
          <div className="bg-warning-subtle">
            <CardBody className="">
              <Row>
                <div className="col-md">
                  {loading ? (
                    <RowSkeleton />
                  ) : (
                    <Row className="align-items-center">
                      <div className="col-md-auto">
                        <div className="avatar-md mb-md-0 mb-4">
                          {/* <div className="avatar-title bg-white rounded-circle"> */}
                          <div className="avatar-md img-thumbnail rounded">
                            <div className="avatar-title bg-primary-subtle rounded fs-24 ">
                              <i className="ri-earth-line text-primary"></i>
                            </div>
                            {/* </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md">
                        <h4 className="fw-semibold" id="ticket-title">
                          {agency?.name || "N/A"}
                        </h4>
                        <div className="hstack gap-3 flex-wrap">
                          <div className="text-muted">
                            <i className="ri-bookmark-line align-bottom me-1"></i>{" "}
                            <span id="ticket-client">
                              {agency?.category?.name || "N/A"}
                            </span>
                          </div>
                          <div className="vr"></div>

                          <div className="text-muted">
                            Created :{" "}
                            <span className="fw-medium">
                              {moment(new Date(agency?.createdAt)).format(
                                "DD MMM, Y"
                              )}
                            </span>
                          </div>
                          <div className="vr"></div>
                          <div className="text-muted">
                            Last Updated :{" "}
                            <span className="fw-medium">
                              {moment(new Date(agency?.updatedAt)).format(
                                "DD MMM, Y"
                              )}
                            </span>
                          </div>

                          {/* <div
                            className="badge rounded-pill bg-danger fs-12"
                            id="ticket-priority"
                          >
                            High
                          </div> */}
                        </div>
                      </div>
                    </Row>
                  )}
                </div>
                <div className="col-md-auto mt-md-0 mt-4">
                  <div className="hstack gap-1 flex-wrap">
                    {/* <UncontrolledDropdown className="float-end">
                      <DropdownToggle
                        tag="a"
                        className="btn py-0 fs-13 material-shadow-none align-middle  text-primary"
                        role="button"
                      >
                        Actions
                        <i className=" ri-arrow-down-s-fill fs-16 ms-1"></i>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-end">
                        <Permission action="update" resource="individual">
                          <DropdownItem
                            href="#"
                            className="edit-item-btn"
                            onClick={(e: any) => {
                              e.preventDefault();
                              showUpdateModalForm();
                            }}
                          >
                            <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                            Edit
                          </DropdownItem>
                        </Permission>
                        <Permission action="delete" resource="individual">
                          <DropdownItem
                            href="#"
                            className="remove-item-btn"
                            onClick={(e: any) => {
                              e.preventDefault();
                              setDeleteModal(true);
                            }}
                          >
                            <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                            Delete
                          </DropdownItem>
                        </Permission>
                      </DropdownMenu>
                    </UncontrolledDropdown> */}
                  </div>
                </div>
              </Row>

              {/* <DeleteModal
                show={deleteModal}
                onDeleteClick={() => handleDelete()}
                onCloseClick={() => setDeleteModal(false)}
                loading={deleting}
              /> */}
            </CardBody>
          </div>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Header;
